const defaultState = () => {
  return {
    registrationData: null
  };
};

const register = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, defaultState());
    },
    setRegistrationData(state, data) {
      state.registrationData = data;
    },
    clearRegistrationData(state) {
      state.registrationData = null;
    }
  },
  actions: {
    resetState({ commit }) {
      commit('resetState');
    },
    setRegistrationData({ commit }, data) {
      commit('setRegistrationData', data);
    },
    clearRegistrationData({ commit }) {
      commit('clearRegistrationData');
    }
  },
  getters: {
    getRegistrationData: state => state.registrationData,
    isRegisteredSuccessfully: state => state.registrationData?.is_registered_successfully || false,
    getRegistrationEmail: state => state.registrationData?.email || ''
  }
};

export default register;
